import React, { useEffect, useState } from "react";
import { useParams, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Stack,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Skeleton,
  Avatar,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { api } from "../../utils/api";

export default function ClientJobs() {
  const { id } = useParams();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/jobs/list.php?client_id=${id}`);
        setJobs(res.jobs || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: "warning.main", width: 48, height: 48 }}>
          <WorkIcon />
        </Avatar>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Client Jobs
          </Typography>
          <Typography variant="body2" color="text.secondary">
            All jobs for client #{id}
          </Typography>
        </Box>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Job #</TableCell>
              <TableCell>Services</TableCell>
              <TableCell>Total Price</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading &&
              [...Array(3)].map((_, i) => (
                <TableRow key={`sk-${i}`}>
                  <TableCell colSpan={5}>
                    <Skeleton height={36} />
                  </TableCell>
                </TableRow>
              ))}
            {!loading && jobs.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    No jobs for this client
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              jobs.map((j) => (
                <TableRow key={j.id} hover>
                  <TableCell>JOB#{j.id}</TableCell>
                  <TableCell>
                    {j.completed_services || 0}/{j.total_services || 0}
                  </TableCell>
                  <TableCell>₹{j.total_price || 0}</TableCell>
                  <TableCell>
                    <Chip size="small" label={j.status || "Pending"} />
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      component={RouterLink}
                      to={`/jobs/${j.id}`}
                      size="small"
                      startIcon={<VisibilityIcon />}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
